const SDK_VERSION = '7.117.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
